import React, { ButtonHTMLAttributes } from 'react';
import Children from '../../interfaces/children.interface';
import ClassName from '../../interfaces/class-name.interface';
import Gap from '../../interfaces/gap.interface';
import Layer from '../../interfaces/layer.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    Children,
    ClassName,
    Gap,
    Layer,
    TestId {
  /** The button's display mode */
  display?: 'inline' | 'block' | 'inline-block' | 'flex';

  /** Click listener */
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;

  /** Enable/disable ghost mode */
  ghost?: boolean;

  /** Render a loading animation */
  isLoading?: boolean;

  /** The button's variant */
  variant?: 'button' | 'link' | 'plain';
}

/** A Button */
const Button = ({
  children,
  className = '',
  disabled = false,
  display = 'inline-block',
  gap = 'none',
  ghost = false,
  isLoading = false,
  layer = 0,
  onClick,
  type = 'button',
  variant = 'button',
  testId,
}: Props): React.ReactElement => (
  // eslint-disable-next-line react/button-has-type
  <button
    className={`
      skeletonize
      disabled:opacity-50
      disabled:cursor-not-allowed
      ${display}
      ${display === 'flex' ? 'items-center' : ''}
      ${display === 'block' ? 'w-full' : ''}
      ${variant === 'link' ? 'link--text' : ''}
      ${variant === 'plain' ? 'btn--plain' : ''}
      ${variant === 'button' ? 'btn' : ''}
      ${ghost ? 'btn--ghost ' : ''}
      ${isLoading ? 'btn--loading' : ''}
      layer--${layer}
      gap--${gap}
      ${className}
    `}
    disabled={disabled}
    // eslint-disable-next-line react/button-has-type
    type={type}
    onClick={onClick}
    data-testid={testId}
  >
    {children}
  </button>
);

export default Button;
